import {
  rootRoute,
  appShellRoute,
  processInvitationRoute,
  redirectToEnvironmentProcessInvitationRoute,
  redirectToOrganizationProcessInvitationRoute,
  redirectToWorkspaceProcessInvitationRoute,
  processInvitationADLogoutRoute,
  processInvitationADRedirectHashProcessRoute,
} from 'pages/AppInit/Routing'
import {
  avioRoute,
  dashboardLayoutRoute,
  dashboardRoute,
  avcInstanceLayoutRoute,
  avcInstanceRoute,
  avcInstanceTasksRoute,
} from 'pages/NWPlatform/AvcSystem/Instances/Instance/Routing'
import {
  alertsRoute,
  avcInstanceTaskLayoutRoute,
  rawRoute as rawInAvcInstanceTaskRoute,
  avcInstanceTaskRoute,
  statusRoute,
} from 'pages/NWPlatform/AvcSystem/Instances/Instance/Task/Routing'
import {
  avcInstancesOverviewLayoutRoute,
  avcInstancesOverviewRoute,
  avcInstancesRoute,
} from 'pages/NWPlatform/AvcSystem/Instances/Routing'
import { avcSystemRoute } from 'pages/NWPlatform/AvcSystem/Routing'
import {
  configRoute as configInCollectionAccessKeyRoute,
  accessKeyLayoutRoute,
  accessKeyRoute,
} from 'pages/NWPlatform/Collections/Collection/AccessKey/Routing'
import {
  accessKeysOverviewRoute,
  configRoute as configInCollectionRoute,
  collectionLayoutRoute,
  rawRoute as rawInCollectionRoute,
  collectionRoute,
  showcasesOverviewRoute,
} from 'pages/NWPlatform/Collections/Collection/Routing'
import {
  configRoute as configInCollectionShowcaseRoute,
  showcaseLayoutRoute,
  rawRoute as rawInCollectionShowcaseRoute,
  showcaseRoute,
} from 'pages/NWPlatform/Collections/Collection/Showcase/Routing'
import {
  collectionsOverviewLayoutRoute,
  collectionsOverviewRoute,
  collectionsRoute,
} from 'pages/NWPlatform/Collections/Routing'
import {
  externalStoreConfigRoute,
  externalStoreLayoutRoute,
  externalStoreRoute,
} from 'pages/NWPlatform/ContentStores/ExternalStores/ExternalStore'
import {
  externalStoresOverviewRoute,
  externalStoresOverviewLayoutRoute,
  externalStoresRoute,
} from 'pages/NWPlatform/ContentStores/ExternalStores/Routing'
import {
  managedStoreConfigRoute,
  managedStoreLayoutRoute,
  managedStoreRoute,
} from 'pages/NWPlatform/ContentStores/ManagedStores/ManagedStore/Routing'
import {
  managedStoresOverviewRoute,
  managedStoresOverviewLayoutRoute,
  managedStoresRoute,
} from 'pages/NWPlatform/ContentStores/ManagedStores/Routing'
import { contentStoresRoute } from 'pages/NWPlatform/ContentStores/Routing'
import { dataProvidersOverviewLayoutRoute, dataProvidersRoute } from 'pages/NWPlatform/DataProviders/Routing'
import { drmProviderIndexRoute, drmProviderLayoutRoute } from 'pages/NWPlatform/DrmProviders/DrmProvider'
import {
  drmProvidersOverviewLayoutRoute,
  drmProvidersOverviewRoute,
  drmProvidersRoute,
} from 'pages/NWPlatform/DrmProviders/Routing'
import {
  environmentLayoutRoute,
  invitationsOverviewRoute as invitationsInEnvironmentsOverviewRoute,
  manageAccessLayoutRoute,
  manageAccessRoute,
  teamsOverviewRoute as teamsInEnvironmentsOverviewRoute,
  usersOverviewRoute as usersInEnvironmentsOverviewRoute,
  permissionLayoutRoute,
} from 'pages/NWPlatform/Environment/Routing'
import { expAppConfigRoute, expAppLayoutRoute, expAppRoute } from 'pages/NWPlatform/ExpApps/ExpApp/Routing'
import { expAppsOverviewLayoutRoute, expAppsOverviewRoute, expAppsRoute } from 'pages/NWPlatform/ExpApps/Routing'
import {
  mediaChannelEntryIndexRoute,
  mediaChannelEntryLayoutRoute,
} from 'pages/NWPlatform/MediaChannels/MediaChannel/MediaChannelEntry/Routing'
import {
  mediaChannelConfigRoute,
  mediaChannelEntriesOverviewRoute,
  mediaChannelLayoutRoute,
  mediaChannelRoute,
} from 'pages/NWPlatform/MediaChannels/MediaChannel/Routing'
import {
  mediaChannelsOverviewLayoutRoute,
  mediaChannelsOverviewRoute,
  mediaChannelsRoute,
} from 'pages/NWPlatform/MediaChannels/Routing'
import {
  mediaLibraryMediaLayoutRoute,
  mediaLibraryMediaIndexRoute,
} from 'pages/NWPlatform/MediaLibraries/MediaLibrary/Media/Routing'
import {
  mediaLibraryRoute,
  mediaLibraryLayoutRoute,
  mediaLibraryConfigRoute,
  mediaLibraryEntriesOverviewRoute,
} from 'pages/NWPlatform/MediaLibraries/MediaLibrary/Routing'
import {
  mediaLibrariesRoute,
  mediaLibrariesOverviewLayoutRoute,
  mediaLibrariesOverviewRoute,
} from 'pages/NWPlatform/MediaLibraries/Routing'
import {
  mediaPlatformsOverviewLayoutRoute,
  mediaPlatformsOverviewRoute,
  mediaPlatformsRoute,
} from 'pages/NWPlatform/MediaPlatforms'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import {
  mediaPlatformAssetsLayoutRoute,
  mediaPlatformAssetsOverviewRoute,
  mediaPlatformAssetsRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Assets'
import {
  mediaPlatformAssetLayoutRoute,
  mediaPlatformAssetRawRoute,
  mediaPlatformAssetRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Assets/Asset'
import {
  mediaPlatformBundlesLayoutRoute,
  mediaPlatformBundlesOverviewRoute,
  mediaPlatformBundlesRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Bundles'
import {
  mediaPlatformBundleLayoutRoute,
  mediaPlatformBundleRawRoute,
  mediaPlatformBundleRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Bundles/Bundle'
import {
  mediaPlatformChannelsLayoutRoute,
  mediaPlatformChannelsOverviewRoute,
  mediaPlatformChannelsRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Channels'
import {
  mediaPlatformChannelLayoutRoute,
  mediaPlatformChannelRawRoute,
  mediaPlatformChannelRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Channels/Channel'
import {
  mediaPlatformEventsLayoutRoute,
  mediaPlatformEventsOverviewRoute,
  mediaPlatformEventsRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Events'
import {
  mediaPlatformEventLayoutRoute,
  mediaPlatformEventRawRoute,
  mediaPlatformEventRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Events/Event'
import {
  mediaPlatformIngestTasksLayoutRoute,
  mediaPlatformIngestTasksOverviewRoute,
  mediaPlatformIngestTasksRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/IngestTasks'
import {
  mediaPlatformIngestTaskLayoutRoute,
  mediaPlatformIngestTaskRawRoute,
  mediaPlatformIngestTaskRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/IngestTasks/IngestTask'
import {
  mediaPlatformOffersLayoutRoute,
  mediaPlatformOffersOverviewRoute,
  mediaPlatformOffersRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Offers'
import {
  mediaPlatformOfferLayoutRoute,
  mediaPlatformOfferRawRoute,
  mediaPlatformOfferRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Offers/Offer'
import {
  mediaPlatformPagesLayoutRoute,
  mediaPlatformPagesOverviewRoute,
  mediaPlatformPagesRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Pages'
import {
  mediaPlatformPageRawRoute,
  mediaPlatformPageLayoutRoute,
  mediaPlatformPageRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Pages/Page'
import {
  mediaPlatformSettingsLayoutRoute,
  mediaPlatformSettingsOverviewRoute,
  mediaPlatformSettingsRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings'
import {
  mediaPlatformSettingsLegalImprintsOverviewRoute,
  mediaPlatformSettingsLegalPrivacyOverviewRoute,
  mediaPlatformSettingsLegalRoute,
  mediaPlatformSettingsLegalTermsOverviewRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings/Legal'
import {
  mediaPlatformSettingsPermissionsInvitesOverviewRoute,
  mediaPlatformSettingsPermissionsRoute,
  mediaPlatformSettingsPermissionsTeamsOverviewRoute,
  mediaPlatformSettingsPermissionsUsersOverviewRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings/Permissions'
import {
  mediaPlatformSettingsRegionsOverviewRoute,
  mediaPlatformSettingsRegionsRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings/Regions'
import {
  mediaPlatformSettingsSetupsOverviewRoute,
  mediaPlatformSettingsSetupsRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings/Setups'
import {
  mediaPlatformSetupLayoutRoute,
  mediaPlatformSetupOverviewRoute,
  mediaPlatformSetupRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Setup'
import {
  mediaPlatformShortsLayoutRoute,
  mediaPlatformShortsOverviewRoute,
  mediaPlatformShortsRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Shorts'
import {
  mediaPlatformShortLayoutRoute,
  mediaPlatformShortRawRoute,
  mediaPlatformShortRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Shorts/Short'
import {
  mediaPlatformSpacesLayoutRoute,
  mediaPlatformSpacesOverviewRoute,
  mediaPlatformSpacesRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces'
import {
  mediaPlatformSpaceLayoutRoute,
  mediaPlatformSpaceRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space'
import {
  mediaPlatformSpacePermissionsInvitesOverviewRoute,
  mediaPlatformSpacePermissionsRoute,
  mediaPlatformSpacePermissionsTeamsOverviewRoute,
  mediaPlatformSpacePermissionsUsersOverviewRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space/Permissions'
import {
  mediaPlatformSpaceSharingOverviewRoute,
  mediaPlatformSpaceSharingRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space/Sharing'
import {
  mediaPlatformVideosLayoutRoute,
  mediaPlatformVideosOverviewRoute,
  mediaPlatformVideosRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Videos'
import {
  mediaPlatformVideoLayoutRoute,
  mediaPlatformVideoRawRoute,
  mediaPlatformVideoRoute,
} from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Videos/Video'
import { environmentsOverviewRoute } from 'pages/NWPlatform/Organizations/Organization/Environments/Routing'
import {
  invitationsOverviewRoute as invitationsInOrganizationMembersOverviewRoute,
  membersLayoutRoute,
  membersRoute,
  teamsOverviewRoute as teamsInMembersOverviewRoute,
  usersOverviewRoute as usersInOrganizationMembersOverviewRoute,
} from 'pages/NWPlatform/Organizations/Organization/Members/Routing'
import {
  organizationTabsOverviewLayoutRoute,
  organizationRoute,
} from 'pages/NWPlatform/Organizations/Organization/Routing'
import { teamsRoute, teamsOverviewRoute } from 'pages/NWPlatform/Organizations/Organization/Teams/Routing'
import {
  teamLayoutRoute,
  membersOverviewRoute,
  teamOverviewRoute,
  teamRoute,
} from 'pages/NWPlatform/Organizations/Organization/Teams/Team/Routing'
import {
  organizationsOverviewLayoutRoute,
  organizationsOverviewRoute,
  organizationsRoute,
} from 'pages/NWPlatform/Organizations/Routing'
import {
  gatewayLayoutRoute,
  gatewayRoute,
  rawRoute as gatewayRawRoute,
} from 'pages/NWPlatform/OriginGateways/Gateway/Routing'
import {
  originGatewaysLayoutRoute,
  originGatewaysOverviewRoute,
  originGatewaysRoute,
} from 'pages/NWPlatform/OriginGateways/Routing'
import { environmentRoute, environmentsRoute, nwPlatformRoute } from 'pages/NWPlatform/Routing'
import {
  workspacesOverviewLayoutRoute,
  workspacesOverviewRoute,
  workspacesRoute,
} from 'pages/NWPlatform/Workspaces/Routing'
import {
  audioObjectRoute,
  audioObjectLayoutRoute,
  audioObjectRawRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Audio/Objects/Object/Routing'
import {
  audioObjectsLayoutRoute,
  audioObjectsOverviewRoute,
  audioObjectsRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Audio/Objects/Routing'
import { audioRoute } from 'pages/NWPlatform/Workspaces/Workspace/Audio/Routing'
import {
  audioStreamsRoute,
  audioStreamsLayoutRoute,
  audioStreamsOverviewRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Audio/Streams/Routing'
import {
  audioStreamRoute,
  audioStreamLayoutRoute,
  audioStreamDashboardLayoutRoute,
  audioStreamGeneralRoute,
  audioStreamConfigRoute,
  audioStreamObjectsOverviewRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Audio/Streams/Stream/Routing'
import {
  avcTaskConfigRoute,
  avcTaskLayoutRoute,
  avcTaskMonitoringRoute,
  avcTaskRawRoute,
  avcTaskRoute,
  avcTaskStatusRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/AvcTask/Routing'
import {
  avcTasksOverviewLayoutRoute,
  contentFlowsRoute,
  avcTasksOverviewRoute,
  avcTasksRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/Routing'
import {
  eventRoute,
  eventLayoutRoute,
  eventConfigRoute,
  eventRawRoute,
  eventDashboardLayoutRoute,
  eventExpManifestRoute,
  eventDashboardRoute,
  eventMonitoringRoute,
  eventWatchRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Events/Event/Routing'
import {
  eventsLayoutRoute,
  eventsOverviewRoute,
  eventsRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Events/Routing'
import {
  expManifestLayoutRoute,
  expManifestRawRoute,
  expManifestRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/ExpManifests/ExpManifest/Routing'
import {
  expManifestsLayoutRoute,
  expManifestsOverviewRoute,
  expManifestsRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/ExpManifests/Routing'
import { imageBlobsOverviewRoute, imageBlobsRoute } from 'pages/NWPlatform/Workspaces/Workspace/Images/Image/Blobs'
import {
  imageRoute,
  imageLayoutRoute,
  rawRoute as imageRawRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Images/Image/Routing'
import {
  imagesOverviewRoute,
  imagesOverviewLayoutRoute,
  imagesRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Images/Routing'
import { workspaceRoute } from 'pages/NWPlatform/Workspaces/Workspace/Routing'
import {
  defaultEventConfigOverviewRoute,
  defaultEventConfigRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Settings/DefaultEventConfig'
import {
  reservationsOverviewRoute,
  reservationsRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Settings/Reservations/Routing'
import {
  workspaceSettingsRoute,
  workspaceSettingsPermissionsInvitationsRoute,
  workspacePermissionsLayoutRoute,
  workspaceSettingsPermissionsRoute,
  workspaceSettingsPermissionsTeamsRoute,
  workspaceSettingsPermissionsUserRoute,
  workspaceSettingsLayoutRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Settings/Routing'
import {
  videoObjectBlobsOverviewRoute,
  videoObjectBlobsRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object/Blobs'
import {
  videoObjectBlobConfigRoute,
  videoObjectBlobLayoutRoute,
  videoObjectBlobRoute,
  videoObjectBlobWatchRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object/Blobs/Blob'
import {
  videoObjectRoute,
  videoObjectLayoutRoute,
  videoObjectConfigRoute,
  videoObjectWatchRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object/Routing'
import {
  videoObjectsRoute,
  videoObjectsLayoutRoute,
  videoObjectsOverviewRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Routing'
import { videoRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Routing'
import {
  videoStreamsRoute,
  videoStreamsLayoutRoute,
  videoStreamsOverviewRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Video/Streams/Routing'
import {
  videoStreamRoute,
  videoStreamLayoutRoute,
  videoStreamConfigRoute,
  videoStreamObjectsOverviewRoute,
  videoStreamWatchRoute,
  videoStreamDashboardLayoutRoute,
  videoStreamGeneralRoute,
} from 'pages/NWPlatform/Workspaces/Workspace/Video/Streams/Stream/Routing'

export const routeTree = rootRoute.addChildren([
  appShellRoute.addChildren([
    processInvitationRoute,
    processInvitationADRedirectHashProcessRoute,
    processInvitationADLogoutRoute,
    redirectToOrganizationProcessInvitationRoute,
    redirectToEnvironmentProcessInvitationRoute,
    redirectToWorkspaceProcessInvitationRoute,
    nwPlatformRoute.addChildren([
      organizationsRoute.addChildren([
        organizationsOverviewLayoutRoute.addChildren([organizationsOverviewRoute]),
        organizationRoute.addChildren([
          organizationTabsOverviewLayoutRoute.addChildren([
            membersLayoutRoute.addChildren([
              membersRoute.addChildren([
                usersInOrganizationMembersOverviewRoute,
                teamsInMembersOverviewRoute,
                invitationsInOrganizationMembersOverviewRoute,
              ]),
            ]),
            teamsOverviewRoute,
            environmentsOverviewRoute,
          ]),

          teamsRoute.addChildren([
            teamRoute.addChildren([teamLayoutRoute.addChildren([membersOverviewRoute, teamOverviewRoute])]),
          ]),
          environmentsRoute.addChildren([
            environmentRoute.addChildren([
              environmentLayoutRoute.addChildren([
                permissionLayoutRoute.addChildren([
                  manageAccessLayoutRoute.addChildren([
                    manageAccessRoute.addChildren([
                      usersInEnvironmentsOverviewRoute,
                      teamsInEnvironmentsOverviewRoute,
                      invitationsInEnvironmentsOverviewRoute,
                    ]),
                  ]),
                ]),
              ]),

              workspacesRoute.addChildren([
                /* START: Workspace */
                workspacesOverviewLayoutRoute.addChildren([workspacesOverviewRoute]),
                workspaceRoute.addChildren([
                  workspaceSettingsRoute.addChildren([
                    reservationsRoute,
                    defaultEventConfigRoute,
                    workspaceSettingsLayoutRoute.addChildren([
                      reservationsOverviewRoute,
                      defaultEventConfigOverviewRoute,
                      workspacePermissionsLayoutRoute.addChildren([
                        workspaceSettingsPermissionsRoute.addChildren([
                          workspaceSettingsPermissionsUserRoute,
                          workspaceSettingsPermissionsTeamsRoute,
                          workspaceSettingsPermissionsInvitationsRoute,
                        ]),
                      ]),
                    ]),
                  ]),
                  contentFlowsRoute.addChildren([
                    avcTasksRoute.addChildren([
                      avcTasksOverviewLayoutRoute.addChildren([avcTasksOverviewRoute]),
                      avcTaskRoute.addChildren([
                        avcTaskLayoutRoute.addChildren([
                          avcTaskConfigRoute,
                          avcTaskStatusRoute,
                          avcTaskMonitoringRoute,
                          avcTaskRawRoute,
                        ]),
                      ]),
                    ]),
                  ]),
                  eventsRoute.addChildren([
                    eventsLayoutRoute.addChildren([eventsOverviewRoute]),
                    eventRoute.addChildren([
                      eventLayoutRoute.addChildren([
                        eventDashboardLayoutRoute.addChildren([eventDashboardRoute]),
                        eventMonitoringRoute,
                        eventConfigRoute,
                        eventExpManifestRoute,
                        eventRawRoute,
                        eventWatchRoute,
                      ]),
                    ]),
                  ]),
                  expManifestsRoute.addChildren([
                    expManifestsLayoutRoute.addChildren([expManifestsOverviewRoute]),
                    expManifestRoute.addChildren([expManifestLayoutRoute.addChildren([expManifestRawRoute])]),
                  ]),
                  videoRoute.addChildren([
                    videoObjectsRoute.addChildren([
                      videoObjectsLayoutRoute.addChildren([videoObjectsOverviewRoute]),
                      videoObjectRoute.addChildren([
                        videoObjectLayoutRoute.addChildren([
                          videoObjectConfigRoute,
                          videoObjectWatchRoute,
                          videoObjectBlobsOverviewRoute,
                        ]),
                        videoObjectBlobsRoute.addChildren([
                          videoObjectBlobRoute.addChildren([
                            videoObjectBlobLayoutRoute.addChildren([
                              videoObjectBlobWatchRoute,
                              videoObjectBlobConfigRoute,
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    videoStreamsRoute.addChildren([
                      videoStreamsLayoutRoute.addChildren([videoStreamsOverviewRoute]),
                      videoStreamRoute.addChildren([
                        videoStreamLayoutRoute.addChildren([
                          videoStreamDashboardLayoutRoute.addChildren([videoStreamGeneralRoute]),
                          videoStreamWatchRoute,
                          videoStreamConfigRoute,
                          videoStreamObjectsOverviewRoute,
                        ]),
                      ]),
                    ]),
                  ]),
                  audioRoute.addChildren([
                    audioObjectsRoute.addChildren([
                      audioObjectsLayoutRoute.addChildren([audioObjectsOverviewRoute]),
                      audioObjectRoute.addChildren([audioObjectLayoutRoute.addChildren([audioObjectRawRoute])]),
                    ]),
                    audioStreamsRoute.addChildren([
                      audioStreamsLayoutRoute.addChildren([audioStreamsOverviewRoute]),
                      audioStreamRoute.addChildren([
                        audioStreamLayoutRoute.addChildren([
                          audioStreamDashboardLayoutRoute.addChildren([audioStreamGeneralRoute]),
                          audioStreamConfigRoute,
                          audioStreamObjectsOverviewRoute,
                        ]),
                      ]),
                    ]),
                  ]),
                  imagesRoute.addChildren([
                    imagesOverviewLayoutRoute.addChildren([imagesOverviewRoute]),
                    imageRoute.addChildren([
                      imageLayoutRoute.addChildren([imageRawRoute, imageBlobsOverviewRoute]),
                      imageBlobsRoute,
                    ]),
                  ]),
                ]),
                /* END */
              ]),

              /* START: Media & OTT */
              mediaLibrariesRoute.addChildren([
                mediaLibrariesOverviewLayoutRoute.addChildren([mediaLibrariesOverviewRoute]),
                mediaLibraryRoute.addChildren([
                  mediaLibraryLayoutRoute.addChildren([mediaLibraryConfigRoute, mediaLibraryEntriesOverviewRoute]),
                  mediaLibraryMediaLayoutRoute.addChildren([mediaLibraryMediaIndexRoute]),
                ]),
              ]),
              mediaPlatformsRoute.addChildren([
                mediaPlatformsOverviewLayoutRoute.addChildren([mediaPlatformsOverviewRoute]),
                mediaPlatformRoute.addChildren([
                  mediaPlatformAssetsRoute.addChildren([
                    mediaPlatformAssetsLayoutRoute.addChildren([mediaPlatformAssetsOverviewRoute]),
                    mediaPlatformAssetRoute.addChildren([
                      mediaPlatformAssetLayoutRoute.addChildren([mediaPlatformAssetRawRoute]),
                    ]),
                  ]),
                  mediaPlatformBundlesRoute.addChildren([
                    mediaPlatformBundlesLayoutRoute.addChildren([mediaPlatformBundlesOverviewRoute]),
                    mediaPlatformBundleRoute.addChildren([
                      mediaPlatformBundleLayoutRoute.addChildren([mediaPlatformBundleRawRoute]),
                    ]),
                  ]),
                  mediaPlatformChannelsRoute.addChildren([
                    mediaPlatformChannelsLayoutRoute.addChildren([mediaPlatformChannelsOverviewRoute]),
                    mediaPlatformChannelRoute.addChildren([
                      mediaPlatformChannelLayoutRoute.addChildren([mediaPlatformChannelRawRoute]),
                    ]),
                  ]),
                  mediaPlatformEventsRoute.addChildren([
                    mediaPlatformEventsLayoutRoute.addChildren([mediaPlatformEventsOverviewRoute]),
                    mediaPlatformEventRoute.addChildren([
                      mediaPlatformEventLayoutRoute.addChildren([mediaPlatformEventRawRoute]),
                    ]),
                  ]),
                  mediaPlatformIngestTasksRoute.addChildren([
                    mediaPlatformIngestTasksLayoutRoute.addChildren([mediaPlatformIngestTasksOverviewRoute]),
                    mediaPlatformIngestTaskRoute.addChildren([
                      mediaPlatformIngestTaskLayoutRoute.addChildren([mediaPlatformIngestTaskRawRoute]),
                    ]),
                  ]),
                  mediaPlatformOffersRoute.addChildren([
                    mediaPlatformOffersLayoutRoute.addChildren([mediaPlatformOffersOverviewRoute]),
                    mediaPlatformOfferRoute.addChildren([
                      mediaPlatformOfferLayoutRoute.addChildren([mediaPlatformOfferRawRoute]),
                    ]),
                  ]),
                  mediaPlatformPagesRoute.addChildren([
                    mediaPlatformPagesLayoutRoute.addChildren([mediaPlatformPagesOverviewRoute]),
                    mediaPlatformPageRoute.addChildren([
                      mediaPlatformPageLayoutRoute.addChildren([mediaPlatformPageRawRoute]),
                    ]),
                  ]),
                  mediaPlatformSettingsRoute.addChildren([
                    mediaPlatformSettingsLayoutRoute.addChildren([
                      mediaPlatformSettingsOverviewRoute,
                      mediaPlatformSettingsLegalRoute.addChildren([
                        mediaPlatformSettingsLegalTermsOverviewRoute,
                        mediaPlatformSettingsLegalImprintsOverviewRoute,
                        mediaPlatformSettingsLegalPrivacyOverviewRoute,
                      ]),
                      mediaPlatformSettingsPermissionsRoute.addChildren([
                        mediaPlatformSettingsPermissionsUsersOverviewRoute,
                        mediaPlatformSettingsPermissionsTeamsOverviewRoute,
                        mediaPlatformSettingsPermissionsInvitesOverviewRoute,
                      ]),
                      mediaPlatformSettingsRegionsRoute.addChildren([mediaPlatformSettingsRegionsOverviewRoute]),
                      mediaPlatformSettingsSetupsRoute.addChildren([mediaPlatformSettingsSetupsOverviewRoute]),
                    ]),
                  ]),
                  mediaPlatformSetupRoute.addChildren([
                    mediaPlatformSetupLayoutRoute.addChildren([mediaPlatformSetupOverviewRoute]),
                  ]),
                  mediaPlatformShortsRoute.addChildren([
                    mediaPlatformShortsLayoutRoute.addChildren([mediaPlatformShortsOverviewRoute]),
                    mediaPlatformShortRoute.addChildren([
                      mediaPlatformShortLayoutRoute.addChildren([mediaPlatformShortRawRoute]),
                    ]),
                  ]),
                  mediaPlatformSpacesRoute.addChildren([
                    mediaPlatformSpacesLayoutRoute.addChildren([mediaPlatformSpacesOverviewRoute]),
                    mediaPlatformSpaceRoute.addChildren([
                      mediaPlatformSpaceLayoutRoute.addChildren([
                        mediaPlatformSpacePermissionsRoute.addChildren([
                          mediaPlatformSpacePermissionsUsersOverviewRoute,
                          mediaPlatformSpacePermissionsTeamsOverviewRoute,
                          mediaPlatformSpacePermissionsInvitesOverviewRoute,
                        ]),
                        mediaPlatformSpaceSharingRoute.addChildren([mediaPlatformSpaceSharingOverviewRoute]),
                      ]),
                    ]),
                  ]),
                  mediaPlatformVideosRoute.addChildren([
                    mediaPlatformVideosLayoutRoute.addChildren([mediaPlatformVideosOverviewRoute]),
                    mediaPlatformVideoRoute.addChildren([
                      mediaPlatformVideoLayoutRoute.addChildren([mediaPlatformVideoRawRoute]),
                    ]),
                  ]),
                ]),
              ]),
              mediaChannelsRoute.addChildren([
                mediaChannelsOverviewLayoutRoute.addChildren([mediaChannelsOverviewRoute]),
                mediaChannelRoute.addChildren([
                  mediaChannelLayoutRoute.addChildren([mediaChannelConfigRoute, mediaChannelEntriesOverviewRoute]),
                  mediaChannelEntryLayoutRoute.addChildren([mediaChannelEntryIndexRoute]),
                ]),
              ]),
              /* END */

              /* START: EXP Applications */
              collectionsRoute.addChildren([
                collectionsOverviewLayoutRoute.addChildren([collectionsOverviewRoute]),
                collectionRoute.addChildren([
                  collectionLayoutRoute.addChildren([
                    configInCollectionRoute,
                    showcasesOverviewRoute,
                    accessKeysOverviewRoute,
                    rawInCollectionRoute,
                  ]),
                  showcaseRoute.addChildren([
                    showcaseLayoutRoute.addChildren([configInCollectionShowcaseRoute, rawInCollectionShowcaseRoute]),
                  ]),
                  accessKeyRoute.addChildren([accessKeyLayoutRoute.addChildren([configInCollectionAccessKeyRoute])]),
                ]),
              ]),
              expAppsRoute.addChildren([
                expAppsOverviewLayoutRoute.addChildren([expAppsOverviewRoute]),
                expAppRoute.addChildren([expAppLayoutRoute.addChildren([expAppConfigRoute])]),
              ]),
              /* END */

              /* START: Content System */
              avcSystemRoute.addChildren([
                avcInstancesRoute.addChildren([
                  avcInstancesOverviewLayoutRoute.addChildren([avcInstancesOverviewRoute]),
                  avcInstanceRoute.addChildren([
                    avcInstanceLayoutRoute.addChildren([
                      dashboardLayoutRoute.addChildren([dashboardRoute]),
                      avcInstanceTasksRoute,
                      avioRoute,
                    ]),
                    avcInstanceTaskRoute.addChildren([
                      avcInstanceTaskLayoutRoute.addChildren([rawInAvcInstanceTaskRoute, statusRoute, alertsRoute]),
                    ]),
                  ]),
                ]),
              ]),
              contentStoresRoute.addChildren([
                managedStoresRoute.addChildren([
                  managedStoresOverviewLayoutRoute.addChildren([managedStoresOverviewRoute]),
                  managedStoreRoute.addChildren([managedStoreLayoutRoute.addChildren([managedStoreConfigRoute])]),
                ]),
                externalStoresRoute.addChildren([
                  externalStoresOverviewLayoutRoute.addChildren([externalStoresOverviewRoute]),
                  externalStoreRoute.addChildren([externalStoreLayoutRoute.addChildren([externalStoreConfigRoute])]),
                ]),
              ]),
              drmProvidersRoute.addChildren([
                drmProvidersOverviewLayoutRoute.addChildren([drmProvidersOverviewRoute]),
                drmProviderLayoutRoute.addChildren([drmProviderIndexRoute]),
              ]),
              dataProvidersRoute.addChildren([dataProvidersOverviewLayoutRoute]),
              originGatewaysRoute.addChildren([
                originGatewaysLayoutRoute.addChildren([originGatewaysOverviewRoute]),
                gatewayRoute.addChildren([gatewayLayoutRoute.addChildren([gatewayRawRoute])]),
              ]),
              /* END */
            ]),
          ]),
        ]),
      ]),
    ]),
  ]),
])
